// Don't put env variables in this file put them in env.ts instead. This is only because there are some extra implications to playwright / sentry.
export const SENTRY_ENABLED = process.env.SENTRY_ENABLED === "true";
export const FLUID_CDN_URL = "https://assets.fluid.app";

export const COMPANIES_TO_HIDE_FLUID_PAY_BRANDING = ["New U Life"];

export const ADDITIONAL_VALID_EMAIL_TLDS = ["app"];
